// This file is automatically generated. Do not edit manually.

import { ProcessDiagramStore_DiagramListItem } from "src/api/generated/spc/processDiagrams/processDiagramStore";
import { ProcessDiagramService_DisplayData } from "src/api/generated/spc/processDiagrams/processDiagramService";
import { SpcResourceState } from "src/api/generated/spc/spcResourceState";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProcessDiagramApi {
	export async function listResources(): Promise<Array<ProcessDiagramStore_DiagramListItem>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/processDiagrams/listResources",
			method: "POST",
			data: {},
		});
		return response as Array<ProcessDiagramStore_DiagramListItem>;
	}

	export async function listChartGroups(): Promise<Array<ProcessDiagramStore_DiagramListItem>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/processDiagrams/listChartGroups",
			method: "POST",
			data: {},
		});
		return response as Array<ProcessDiagramStore_DiagramListItem>;
	}

	export async function getResourceDisplayData(args: {
		resourceId: number;
	}): Promise<ProcessDiagramService_DisplayData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/processDiagrams/getResourceDisplayData",
			method: "POST",
			data: {
				resourceId: args.resourceId,
			},
		});
		return response as ProcessDiagramService_DisplayData;
	}

	export async function getChartGroupDisplayData(args: {
		chartGroupId: number;
	}): Promise<ProcessDiagramService_DisplayData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/processDiagrams/getChartGroupDisplayData",
			method: "POST",
			data: {
				chartGroupId: args.chartGroupId,
			},
		});
		return response as ProcessDiagramService_DisplayData;
	}

	export async function setResourceState(args: {
		resourceId: number;
		newItemId: number | null | undefined;
		newState: SpcResourceState;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/processDiagrams/setResourceState",
			method: "POST",
			data: {
				resourceId: args.resourceId,
				newItemId: args.newItemId,
				newState: args.newState,
			},
		});
		return response as void;
	}
}
